"use client";

import { clsx } from "clsx";
import { useState } from "react";
import NextLink from "next/link";

export type ChapterItem = {
  sectionId: string;
  id: string;
  label: string;
};
export type ChapterSelectorProperties = {
  items: ChapterItem[];
  firstSectionId: string | null;
  lastSectionId: string | null;
  theme?: "light" | "dark";
};
export const ChapterSelector = ({
  items,
  firstSectionId,
  lastSectionId,
  theme,
}: ChapterSelectorProperties) => {
  const [activeSectionId, setActiveSectionId] = useState(firstSectionId);
  const isLastActive = activeSectionId === lastSectionId;
  const isDark = theme === "dark";

  return (
    <div
      className="
        container mx-auto mt-4 w-auto

        max-md:px-4
      "
    >
      <div className="relative">
        <div className="overflow-x-auto p-2">
          <nav
            className="
              flex min-w-max gap-2 bg-background-surface-container-variant-low

              data-[is-dark=true]:bg-background-primary-variant
            "
            data-is-dark={isDark}
          >
            {items.map((chapter) => {
              const isActive = activeSectionId === chapter.sectionId;
              return (
                <NextLink
                  className={clsx(
                    `
                      h-22 w-33 shrink-0 cursor-pointer p-1 text-label

                      focus-within:outline-2 focus-within:outline-offset-3
                      focus-within:outline-foreground-on-surface

                      focus-visible:shadow-[0_0_0_3px_white]

                      md:size-auto md:flex-1 md:shrink
                    `,
                    isDark
                      ? {
                          "bg-background-primary-variant text-foreground-on-primary focus-within:bg-white/85 focus-within:text-foreground-primary hover:bg-white/85 hover:text-foreground-primary":
                            !isActive,
                          "bg-background-surface-variant-low text-foreground-primary-variant":
                            isActive,
                        }
                      : {
                          "bg-background-primary text-foreground-on-primary":
                            isActive,
                          "bg-background-surface-container-variant-low text-foreground-primary-variant focus-within:bg-background-primary-variant focus-within:text-foreground-on-primary hover:bg-background-primary-variant hover:text-foreground-on-primary":
                            !isActive,
                        },
                  )}
                  href={`#${chapter.sectionId}`}
                  key={chapter.id}
                  onClick={() => {
                    setActiveSectionId(chapter.sectionId);
                  }}
                  onFocus={(event) => {
                    event.target.scrollIntoView({
                      behavior: "smooth",
                      block: "nearest",
                      inline: "center",
                    });
                  }}
                >
                  {chapter.label}
                </NextLink>
              );
            })}
          </nav>
        </div>

        <div
          className={clsx(
            `
              pointer-events-none absolute inset-y-2 end-0 w-36 bg-linear-to-l
              from-light-gray to-transparent

              data-[is-dark=true]:from-core-blue

              lg:hidden
            `,
            { hidden: isLastActive },
          )}
          data-is-dark={isDark}
        />
      </div>
    </div>
  );
};
